<template>
     <section v-if="msp.mspGeoContent.content">
        <div class="grid xs-grid-cols-1" v-html="msp.mspGeoContent.content">
        </div>
    </section>
    <section v-if="msp.mspGeoContent.city_life">
        <div class="grid xs-grid-cols-1">
            <h2 class="f4 text-bold">What’s it like to live in {{getGeoDisplayText}}?</h2>
            <div v-html="msp.mspGeoContent.city_life"></div>
        </div>
    </section>
    <section v-if="msp.mspGeoContent.popular_areas">
        <div class="grid xs-grid-cols-1">
            <h2 class="f4 text-bold">Popular areas in {{getGeoDisplayText}}</h2>
            <div v-html="msp.mspGeoContent.popular_areas"></div>
        </div>
    </section>
    <section v-if="msp.mspGeoContent.housing_economy_jobs">
        <div class="grid xs-grid-cols-1">
            <h2 class="f4 text-bold">{{geoName}} housing, economy, and jobs</h2>
            <div v-html="msp.mspGeoContent.housing_economy_jobs"></div>
        </div>
    </section>
    <section v-if="msp.mspGeoContent.school">
        <div class="grid xs-grid-cols-1">
            <h2 class="f4 text-bold">Schools and School Districts in {{getGeoDisplayText}}</h2>
            <div> {{msp.mspGeoContent.school}} <a class="link" :href="getSchoolsLink">See all {{getGeoDisplayText}} schools.</a> </div>
            <div class="f7 text-gray">{{ molang('search.common.ratingsProvided') }} <img class="school-img" :src="glb.cdnUrl + 'images/desktop/s-img/greatschool-inline.png'" alt="great school" loading="lazy" /></div>
        </div>
    </section>
    <section v-if="msp.mspGeoContent.city_love">
        <div class="grid xs-grid-cols-1">
            <h2 class="f4 text-bold">Why residents love {{getGeoDisplayText}}</h2>
            <div v-html="msp.mspGeoContent.city_love"></div>
        </div>
    </section>
</template>

<script src="./search-geo-content.js"></script>
